import { c as _c } from "react/compiler-runtime";
import type { WithContext, FAQPage } from 'schema-dts';
import type { Faq } from '@sbt-web/network/types';
interface Props {
  data: Faq;
}
const generateStructuredData = (data: Faq): WithContext<FAQPage> => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: data.faq.map(({
      question,
      answer
    }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer
      }
    }))
  };
};
export const FAQStructuredData = t0 => {
  const $ = _c(4);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    t1 = JSON.stringify(generateStructuredData(data));
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};